import { useTranslations } from '@vocab/react';
import {
  Box,
  Button,
  Column,
  Columns,
  Heading,
  IconSearch,
  Stack,
  Text,
  TextField,
} from 'braid-design-system';
import React, { type FC, type FormEventHandler } from 'react';

import translations from './.vocab';

interface HeadingAndSearchProps {
  searchTerm: {
    value: string;
    onChange: FormEventHandler<HTMLInputElement>;
    onBlur: FormEventHandler<HTMLInputElement>;
  };
}

export const HeadingAndSearch: FC<HeadingAndSearchProps> = ({ searchTerm }) => {
  const { t } = useTranslations(translations);
  return (
    <Stack space="large">
      <Heading level="2">{t('Candidates')}</Heading>
      <Text size="large">{t('Search for current and past candidates')}</Text>
      <Box maxWidth="small">
        <Columns space="small">
          <Column>
            <TextField
              value={searchTerm.value}
              onChange={searchTerm.onChange}
              onBlur={searchTerm.onBlur}
              icon={<IconSearch />}
              id="search-text"
              aria-label={t('Search by name, job title, email')}
              placeholder={t('Search by name, job title, email')}
            />
          </Column>
          <Column width="content">
            <Button tone="brandAccent" type="submit">
              {t('Search')}
            </Button>
          </Column>
        </Columns>
      </Box>
    </Stack>
  );
};
